document.addEventListener('DOMContentLoaded', function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setOverlay(overlay, open) {
    if (!overlay) return;
    overlay.hidden = !open;
    document.body.classList.toggle('hoxen-lock', open);
  }

  var searchOverlay = document.querySelector('[data-search-overlay]');
  document.querySelectorAll('[data-search-open]').forEach(function(link){
    link.addEventListener('click', function(e){ e.preventDefault(); setOverlay(searchOverlay, true); var input=searchOverlay && searchOverlay.querySelector('input[name="q"]'); if(input) setTimeout(function(){input.focus();},50); });
  });
  document.querySelectorAll('[data-search-close]').forEach(function(btn){ btn.addEventListener('click', function(){ setOverlay(searchOverlay, false); }); });

  var cartOverlay = document.querySelector('[data-cart-overlay]');
  document.querySelectorAll('[data-cart-open]').forEach(function(link){
    link.addEventListener('click', function(e){ e.preventDefault(); refreshCart(true); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function(btn){ btn.addEventListener('click', function(){ setOverlay(cartOverlay, false); }); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ setOverlay(searchOverlay,false); setOverlay(cartOverlay,false); } });

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF'}).format(cents/100);
    } catch(e) { return 'CHF ' + (cents/100).toFixed(2); }
  }

  function escapeHtml(str){ var div=document.createElement('div'); div.textContent=str || ''; return div.innerHTML; }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var foot = document.querySelector('[data-cart-drawer-foot]');
    var total = document.querySelector('[data-cart-total]');
    document.querySelectorAll('[data-cart-count],[data-header-cart-count]').forEach(function(el){ el.textContent='(' + cart.item_count + ')'; });
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="hoxen-drawer-empty">YOUR BAG IS EMPTY.</div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function(item){
      var image = item.image ? '<a href="'+item.url+'" class="hoxen-mini-line__image"><img src="'+item.image+'" alt=""></a>' : '<span></span>';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>'+escapeHtml(item.variant_title)+'</small>' : '';
      return '<div class="hoxen-mini-line" data-line-key="'+item.key+'">'+image+'<div class="hoxen-mini-line__info"><a href="'+item.url+'">'+escapeHtml(item.product_title)+'</a>'+variant+'<span>'+money(item.final_price)+'</span><div class="hoxen-mini-line__qty"><button type="button" data-cart-change="'+item.key+'" data-quantity="'+Math.max(0,item.quantity-1)+'">−</button><span>'+item.quantity+'</span><button type="button" data-cart-change="'+item.key+'" data-quantity="'+(item.quantity+1)+'">+</button></div></div></div>';
    }).join('');
    if (foot) foot.hidden = false;
    if (total) total.textContent = money(cart.total_price);
  }

  function refreshCart(openAfter) {
    fetch(root + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); if(openAfter) setOverlay(cartOverlay,true); })
      .catch(function(){ if(openAfter) window.location.href = root + 'cart'; });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    btn.disabled = true;
    fetch(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:btn.getAttribute('data-cart-change'),quantity:Number(btn.getAttribute('data-quantity'))})})
      .then(function(r){ return r.json(); }).then(function(cart){ renderCart(cart); }).catch(function(){ window.location.href=root+'cart'; });
  });

  document.querySelectorAll('[data-hoxen-product-form]').forEach(function(form){
    var variantInput = form.querySelector('input[name="id"]');
    var selects = Array.from(form.querySelectorAll('select[data-option-position]'));
    var addButton = form.querySelector('[data-add-to-bag]');
    var status = form.querySelector('[data-product-status]');
    var priceEl = document.querySelector('[data-product-price]');
    var variants = [];
    try { variants = JSON.parse(form.getAttribute('data-variants') || '[]'); } catch(e) {}

    function syncVariant(){
      if (!selects.length || !variants.length) return;
      var selected = selects.map(function(s){ return s.value; });
      var variant = variants.find(function(v){ return selected.every(function(value,index){ return v.options[index] === value; }); });
      if (variant) {
        variantInput.value = variant.id;
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
        if(priceEl) priceEl.textContent = money(variant.price);
      }
    }
    selects.forEach(function(s){ s.addEventListener('change', syncVariant); });
    syncVariant();

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(addButton.disabled) return;
      addButton.disabled = true;
      if(status) status.textContent = 'ADDING…';
      var data = new FormData(form);
      fetch(root + 'cart/add.js', {method:'POST',headers:{'Accept':'application/json'},body:data})
        .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
        .then(function(){ if(status) status.textContent='ADDED TO BAG'; return refreshCart(true); })
        .catch(function(){ form.submit(); })
        .finally(function(){ addButton.disabled=false; });
    });
  });
});

// HOXEN V13: reveal themes only after Women / Men / Couples is selected.
document.addEventListener('DOMContentLoaded', function () {
  var browser = document.querySelector('[data-hoxen-audience-browser]');
  if (!browser) return;

  var triggers = Array.from(browser.querySelectorAll('[data-audience-trigger]'));
  var panels = Array.from(browser.querySelectorAll('[data-audience-panel]'));

  function openAudience(name, shouldScroll) {
    triggers.forEach(function (trigger) {
      var active = trigger.getAttribute('data-audience-trigger') === name;
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
    });
    panels.forEach(function (panel) {
      var active = panel.getAttribute('data-audience-panel') === name;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      if (active && shouldScroll) {
        setTimeout(function(){ panel.scrollIntoView({behavior:'smooth', block:'start'}); }, 20);
      }
    });
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      openAudience(trigger.getAttribute('data-audience-trigger'), true);
    });
  });

  document.querySelectorAll('[data-header-audience]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!document.querySelector('[data-hoxen-audience-browser]')) return;
      event.preventDefault();
      var name = link.getAttribute('data-header-audience');
      document.getElementById('shop-by-category').scrollIntoView({behavior:'smooth', block:'start'});
      setTimeout(function(){ openAudience(name, false); }, 250);
    });
  });
});

// HOXEN V15 product gallery + variant selection
(function(){
  function initProduct(){
    var rootEl=document.querySelector('[data-product-root]'); if(!rootEl) return;
    var gallery=rootEl.querySelector('[data-product-gallery]');
    var slides=gallery ? Array.from(gallery.querySelectorAll('[data-product-slide]')) : [];
    var dots=Array.from(rootEl.querySelectorAll('[data-gallery-dot]'));
    function go(i){ if(!gallery||!slides[i]) return; gallery.scrollTo({left:slides[i].offsetLeft,behavior:'smooth'}); }
    var prev=rootEl.querySelector('[data-gallery-prev]'), next=rootEl.querySelector('[data-gallery-next]');
    function current(){ if(!gallery||!gallery.clientWidth)return 0; return Math.max(0,Math.min(slides.length-1,Math.round(gallery.scrollLeft/gallery.clientWidth))); }
    if(prev) prev.addEventListener('click',function(){go(Math.max(0,current()-1));});
    if(next) next.addEventListener('click',function(){go(Math.min(slides.length-1,current()+1));});
    dots.forEach(function(d){d.addEventListener('click',function(){go(Number(d.getAttribute('data-gallery-dot')));});});
    if(gallery) gallery.addEventListener('scroll',function(){window.requestAnimationFrame(function(){var i=current();dots.forEach(function(d,n){d.classList.toggle('is-active',n===i);});});},{passive:true});

    var form=rootEl.querySelector('.hoxen-product-form'); if(!form) return;
    var json=form.querySelector('[data-product-variants]'), variants=[]; try{variants=JSON.parse(json.textContent||'[]');}catch(e){}
    var radios=Array.from(form.querySelectorAll('input[data-option-position]')), idInput=form.querySelector('[data-variant-id]'), add=form.querySelector('[data-add-to-bag]'), price=rootEl.querySelector('[data-product-price]'), status=form.querySelector('[data-product-status]');
    function money(c){try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'CHF'}).format(c/100);}catch(e){return 'CHF '+(c/100).toFixed(2);}}
    function sync(){var opts=[];radios.filter(function(r){return r.checked;}).forEach(function(r){opts[Number(r.getAttribute('data-option-position'))]=r.value;});var v=variants.find(function(x){return opts.every(function(o,i){return x.options[i]===o;});});if(!v)return;if(idInput)idInput.value=v.id;if(price)price.textContent=money(v.price);if(add){add.disabled=!v.available;add.textContent=v.available?'ADD TO BAG':'SOLD OUT';}}
    radios.forEach(function(r){r.addEventListener('change',sync);}); sync();
    form.addEventListener('submit',function(e){e.preventDefault();if(add&&add.disabled)return;if(add)add.disabled=true;if(status)status.textContent='ADDING…';fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)}).then(function(r){if(!r.ok)throw new Error();return r.json();}).then(function(){if(status)status.textContent='ADDED TO BAG'; if(typeof refreshCart==='function')return refreshCart(true); window.location.href=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart';}).catch(function(){form.submit();}).finally(function(){if(add)add.disabled=false;});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initProduct);else initProduct();
})();
